import React from 'react'
import { Box } from '@mui/material'
import KingpolisLogo from '../assets/kingpolis-logo.svg'

const MainLogo = (props) => {
  return <Box>
    <img src={KingpolisLogo} alt="Kingpolis" style={{
      width: '250px',
    }} />
  </Box>
}

export default MainLogo;
